import { createFileRoute } from "@tanstack/react-router"
import { ZendeskIntegration } from "modules/settings/components/integrations/zendesk"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/zendesk")({
  component: ZendeskIntegration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.zendesk.title"),
    })
  },
})
